import React from 'react';
import './BusinessProcessFlow.css';

const BusinessProcessFlow = ({
  workflowStages,
  currentStage,
  showTooltip = true
}) => {
  if (!workflowStages || workflowStages.length === 0) {
    return null;
  }

  const getCurrentStageIndex = () => {
    if (!currentStage) return -1;
    return workflowStages.findIndex(s => s.id === currentStage);
  };

  const isStageCompleted = (index) => {
    const currentIndex = getCurrentStageIndex();
    return currentIndex > index;
  };

  const isCurrentStage = (stage) => {
    return currentStage === stage.id;
  };

  const getStageClassName = (stage, index) => {
    if (isCurrentStage(stage)) return 'current';
    if (isStageCompleted(index)) return 'completed';
    return 'pending';
  };

  const getLineClassName = (index) => {
    if (isStageCompleted(index)) return 'completed';
    if (getCurrentStageIndex() === index) return 'current';
    return 'pending';
  };

  const renderStageContent = (stage, index) => {
    if (isCurrentStage(stage)) {
      return <span>{index + 1}</span>;
    }

    if (isStageCompleted(index)) {
      return <i className="bi bi-check-circle-fill"></i>;
    }

    return <span>{index + 1}</span>;
  };  return (
    <div className="business-process-flow">
      <div className="process-flow-container">
        {workflowStages.map((stage, index) => (
          <div key={stage.id} className="process-stage">
            <div className="process-line-container">
              {index > 0 && (
                <div className={`process-line ${getLineClassName(index)}`} />
              )}
              <div className={`process-circle ${getStageClassName(stage, index)}`}>
                {renderStageContent(stage, index)}
              </div>
            </div>
            <div 
              className={`process-label ${isCurrentStage(stage) ? 'current' : ''}`}
            >
              {stage.stage_name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessProcessFlow;